var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Reporting', []).config(routes);
    ;
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('report', {
            url: '/report/:id',
            templateUrl: qmcBase + '/Reporting',
            controller: 'ReportingController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: report');
                    }]
            }
        });
        $stateProvider
            .state('reportpreview', {
            url: '/reportpreview/',
            templateUrl: qmcBase + '/Reporting/ReportPreview',
            controller: 'ReportPreviewListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: reportpreview');
                    }]
            }
        });
        $stateProvider
            .state('reportpreviewdetail', {
            url: '/reportpreview/:id',
            templateUrl: qmcBase + '/Reporting/ReportPreview',
            controller: 'ReportPreviewListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: reportpreviewdetail');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Reporting.HttpProvider = HttpProvider;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Reporting')
        .config(['$httpProvider', QMC.Reporting.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        /** Mirrors QMC.Data.CustomParams.CustomParamHelper special value ids. */
        class ReportingSpecialValues {
            static getOptions() {
                return [
                    { value: ReportingSpecialValues.GC_PARAMSPEZIAL_HEUTE, text: 'Heute' },
                    { value: ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_MONATS, text: 'Anfang des Monats' },
                    { value: ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_MONATS, text: 'Ende des Monats' },
                    { value: ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_JAHRES, text: 'Anfang des Jahres' },
                    { value: ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_JAHRES, text: 'Ende des Jahres' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginLastMonth, text: 'Anfang letzter Monat' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndLastMonth, text: 'Ende letzter Monat' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginNextMonth, text: 'Anfang nächster Monat' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndNextMonth, text: 'Ende nächster Monat' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginLastYear, text: 'Anfang letztes Jahr' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndLastYear, text: 'Ende letztes Jahr' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginNextYear, text: 'Anfang nächstes Jahr' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndNextYear, text: 'Ende nächstes Jahr' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginQ1, text: 'Anfang Q1' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndQ1, text: 'Ende Q1' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginQ2, text: 'Anfang Q2' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndQ2, text: 'Ende Q2' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginQ3, text: 'Anfang Q3' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndQ3, text: 'Ende Q3' },
                    { value: ReportingSpecialValues.GcSpecialParam_BeginQ4, text: 'Anfang Q4' },
                    { value: ReportingSpecialValues.GcSpecialParam_EndQ4, text: 'Ende Q4' }
                ];
            }
            static resolveDate(specialValue) {
                const now = moment();
                switch (specialValue) {
                    case ReportingSpecialValues.GC_PARAMSPEZIAL_HEUTE:
                        return now.startOf('day').toDate();
                    case ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_MONATS:
                        return now.clone().startOf('month').toDate();
                    case ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_MONATS:
                        return now.clone().endOf('month').startOf('day').toDate();
                    case ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_JAHRES:
                        return now.clone().startOf('year').toDate();
                    case ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_JAHRES:
                        return now.clone().endOf('year').startOf('day').toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginLastMonth:
                        return now.clone().subtract(1, 'month').startOf('month').toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndLastMonth:
                        return now.clone().subtract(1, 'month').endOf('month').startOf('day').toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginNextMonth:
                        return now.clone().add(1, 'month').startOf('month').toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndNextMonth:
                        return now.clone().add(1, 'month').endOf('month').startOf('day').toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginLastYear:
                        return now.clone().subtract(1, 'year').startOf('year').toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndLastYear:
                        return now.clone().subtract(1, 'year').endOf('year').startOf('day').toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginNextYear:
                        return now.clone().add(1, 'year').startOf('year').toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndNextYear:
                        return now.clone().add(1, 'year').endOf('year').startOf('day').toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginQ1:
                        return moment({ year: now.year(), month: 0, day: 1 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndQ1:
                        return moment({ year: now.year(), month: 2, day: 31 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginQ2:
                        return moment({ year: now.year(), month: 3, day: 1 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndQ2:
                        return moment({ year: now.year(), month: 5, day: 30 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginQ3:
                        return moment({ year: now.year(), month: 6, day: 1 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndQ3:
                        return moment({ year: now.year(), month: 8, day: 30 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_BeginQ4:
                        return moment({ year: now.year(), month: 9, day: 1 }).toDate();
                    case ReportingSpecialValues.GcSpecialParam_EndQ4:
                        return moment({ year: now.year(), month: 11, day: 31 }).toDate();
                    default:
                        return null;
                }
            }
            static toDateOnlyString(dateValue) {
                if (!dateValue)
                    return '';
                return moment(dateValue).format('YYYY-MM-DD');
            }
            static normalizeDateValue(value) {
                if (!value)
                    return '';
                if (moment(value, 'YYYY-MM-DD', true).isValid())
                    return moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
                if (moment(value, 'DD.MM.YYYY', true).isValid())
                    return moment(value, 'DD.MM.YYYY').format('YYYY-MM-DD');
                if (moment(value).isValid())
                    return moment(value).format('YYYY-MM-DD');
                return value.substring(0, 10);
            }
        }
        ReportingSpecialValues.GC_PARAMSPEZIAL_HEUTE = 1;
        ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_MONATS = 2;
        ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_MONATS = 3;
        ReportingSpecialValues.GC_PARAMSPEZIAL_ANFANG_DES_JAHRES = 4;
        ReportingSpecialValues.GC_PARAMSPEZIAL_ENDE_DES_JAHRES = 5;
        ReportingSpecialValues.GcSpecialParam_BeginLastMonth = 10;
        ReportingSpecialValues.GcSpecialParam_EndLastMonth = 11;
        ReportingSpecialValues.GcSpecialParam_BeginNextMonth = 12;
        ReportingSpecialValues.GcSpecialParam_EndNextMonth = 13;
        ReportingSpecialValues.GcSpecialParam_BeginLastYear = 20;
        ReportingSpecialValues.GcSpecialParam_EndLastYear = 21;
        ReportingSpecialValues.GcSpecialParam_BeginNextYear = 22;
        ReportingSpecialValues.GcSpecialParam_EndNextYear = 23;
        ReportingSpecialValues.GcSpecialParam_BeginQ1 = 30;
        ReportingSpecialValues.GcSpecialParam_EndQ1 = 31;
        ReportingSpecialValues.GcSpecialParam_BeginQ2 = 32;
        ReportingSpecialValues.GcSpecialParam_EndQ2 = 33;
        ReportingSpecialValues.GcSpecialParam_BeginQ3 = 34;
        ReportingSpecialValues.GcSpecialParam_EndQ3 = 35;
        ReportingSpecialValues.GcSpecialParam_BeginQ4 = 36;
        ReportingSpecialValues.GcSpecialParam_EndQ4 = 37;
        Reporting.ReportingSpecialValues = ReportingSpecialValues;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        let ReportingService = class ReportingService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Reporting';
            }
            getReportTemplateList(objectType) {
                return super.get(this.modulePath + '/Template/' + objectType, {}, (data) => {
                    return data;
                });
            }
            getUnfetchedReportList() {
                return super.get(this.modulePath + '/Job/UnfetchedReportJobList', {}, (data) => {
                    return data;
                });
            }
            getFinishedReportList(unfetchedOnly = false, daysInPast = 365, page = -1, pageSize = -1, listSearch = null, searchProperties = [], sortBy = '', sortDescending = false) {
                return super.getItem(this.modulePath + '/Job/FinishedReportJobs', { unfetchedOnly: unfetchedOnly, daysInPast: daysInPast, page: page, pageSize: pageSize, listSearch: listSearch, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getReportParameterList(id, reportType) {
                return super.get(this.modulePath + '/Parameter/' + id + '/' + reportType, {}, (data) => {
                    return data;
                });
            }
            getReportParameterValueList(fieldType, valueRange) {
                return super.get(this.modulePath + '/Parameter/Value/' + fieldType + '/' + valueRange, {}, (data) => {
                    return data;
                });
            }
            getNewReportJobGuid() {
                return super.get(this.modulePath + '/Job/NewGuid', {}, (data) => {
                    return data;
                });
            }
            getFinishedReportBase64(reportJobObjectId, reportTypeValue, reportName) {
                return this.getFinishedReportFile({
                    objectId: reportJobObjectId,
                    serverJobType: reportTypeValue,
                    reportName: reportName,
                });
            }
            getFinishedReportFile(data) {
                return super.getItem(this.modulePath + '/Job/DownloadFinishedReport/', { finishedReportJobItemId: data.objectId, serverJobType: data.serverJobType, reportName: data.reportName }, (data) => {
                    return data;
                });
            }
            getFinishedSpreadServerJobAsPdf(objectId, reportName) {
                return super.getItem(this.modulePath + '/Job/DownloadFinishedSpreadReportAsPdf/', { finishedServerJobItemId: objectId, spreadServerJobName: reportName }, (data) => {
                    return data;
                });
            }
            /**
             * Posts a report job. Optionally pass a cancel promise (e.g. from scope $destroy);
             * when it is resolved, the request is aborted.
             */
            postReportJob(data, cancelPromise) {
                const options = cancelPromise ? { timeout: cancelPromise } : undefined;
                const post = super.post;
                return post.call(this, this.modulePath + '/Job', data, options).then((data) => {
                    return data;
                });
            }
            markReportFetched(payload) {
                return super.put(this.modulePath + '/Job/MarkFetched/' + payload, {}).then((data) => {
                    return data;
                });
            }
            cancelRunningReportJob(id) {
                super.delete(this.modulePath + '/Job/' + id);
            }
            deleteSelectedReport(data) {
                return super.post(this.modulePath + '/Job/DeleteFinishedReport/', data).then((data) => {
                    return data;
                });
            }
            deleteSelectedReports(data) {
                return super.post(this.modulePath + '/Job/DeleteMultipleFinishedReports/', data).then((data) => {
                    return data;
                });
            }
            getDetailReportReferencesByObjectType(objectType) {
                return super.get(this.modulePath + '/Parameter/DetailReference/' + objectType, {}, (data) => {
                    return data;
                });
            }
        };
        ReportingService = __decorate([
            QMC.Service('QMC.Reporting', 'ReportingService'),
            QMC.Inject('$http', '$q')
        ], ReportingService);
        Reporting.ReportingService = ReportingService;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        let ReportingController = class ReportingController {
            constructor(reportingService, $qui, $state, $scope, $rootScope, mediaService, $q) {
                this.reportingService = reportingService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.mediaService = mediaService;
                this.$q = $q;
                this.parameterValueFilterText = "";
                this.postReportJobCancel = null;
                this.dateParameterWatcherDeregistrations = [];
                this.isLoadingParams = false;
                this.isParamsLoadingError = false;
                this.loadingParamValues = false;
                this.onlyActive = true;
                this.showIsCurrent = false;
                this.detailParams = [];
                this.selectedDetailId = QMC.Common.Constants.GUID_EMPTY;
                this.explanationFile = {
                    isLoading: false
                };
                this.scrollTarget = '';
                this.templateList = [];
                this.$scope.$on('$destroy', () => {
                    if (this.postReportJobCancel) {
                        this.postReportJobCancel.resolve();
                    }
                });
                this.events();
                this.getReportingTemplates();
                $qui.init($qui.getSectionColor(this.getPrevState()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
            }
            getPrevState() {
                if (this.$rootScope.currentState === (null || undefined) || this.$rootScope.currentState.name === (null || undefined))
                    return "/";
                console.log(this.$rootScope.currentState.name);
                switch (this.$rootScope.currentState.name) {
                    case 'medicament': return "/medicament";
                    case 'journal': return "/journal";
                    case 'medicamentDistribution': return "/medicament/plannedDistribution";
                    case 'stammdaten.page': return "/stammdaten";
                    case 'stammdaten': return "/stammdaten";
                    default: return "/";
                }
            }
            events() {
                this.$scope.$watch('vm.selectedTemplateId', (value) => {
                    if (value !== undefined) {
                        this.getAvailableParameters(value);
                    }
                });
                this.$scope.$watch('vm.paramDateFilter.dateFrom', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (this.paramDateFilter.dateFrom && this.paramDateFilter.dateTo && this.paramDateFilter.dateFrom > this.paramDateFilter.dateTo) {
                            this.paramDateFilter.dateFrom = this.paramDateFilter.dateTo;
                        }
                    }
                });
                this.$scope.$watch('vm.paramDateFilter.dateTo', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (this.paramDateFilter.dateFrom && this.paramDateFilter.dateTo && this.paramDateFilter.dateFrom > this.paramDateFilter.dateTo) {
                            this.paramDateFilter.dateFrom = this.paramDateFilter.dateTo;
                        }
                    }
                });
                this.$scope.$watch('vm.selectAll', (newValue, oldValue) => {
                    if (oldValue !== newValue) {
                        this.toggleAllCheckboxes();
                    }
                });
            }
            getNewGuid() {
                let d = new Date().getTime();
                const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    const r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }
            getReportingTemplates() {
                this.reportingService.getReportTemplateList(this.$state.params.id).then((data) => {
                    this.templateList = data;
                    this.templateMap = this.templateList.map(x => ({ value: x.objectId, text: x.name, group: x.categoryName, icon: this.getIcon(x) }));
                    if (data.length > 0)
                        this.getAvailableParameters(data[0].objectId);
                });
            }
            getIcon(item) {
                switch (item.reportTypeValue) {
                    case 7000:
                        return 'qm-icon-document_text';
                    case 3000:
                        return 'qm-icon-document_page_number';
                }
                return 'qm-icon-document_information';
            }
            getDetailParams(objectType) {
                this.loadingDetailParams = true;
                this.reportingService.getDetailReportReferencesByObjectType(objectType).then((data) => {
                    this.detailParams = data.map(x => ({ value: x.objectId, text: x.name }));
                    this.loadingDetailParams = false;
                });
            }
            getAvailableParameters(id) {
                var _a;
                this.base64Data = ''; //clean last reports data to hide viewer
                this.isLoadingParams = true;
                this.isParamsLoadingError = false;
                this.selectedTemplateId = id;
                const reportType = this.getReportType();
                if (((_a = this.templateList.filter(x => x.objectId === id)[0]) === null || _a === void 0 ? void 0 : _a.isDetail) && (!this.detailParams || this.detailParams.length === 0)) {
                    this.getDetailParams(this.$state.params.id);
                }
                this.reportingService.getReportParameterList(id, reportType).then((data) => {
                    this.isLoadingParams = false;
                    this.availableParameters = data;
                    // Init values
                    for (let i = 0; i < this.availableParameters.length; i++) {
                        // Init boolean values (default: false, if user set default value: take this)
                        if (this.availableParameters[i].fieldTypeName === 'Boolean' && this.availableParameters[i].chosenValues.length >= 1) {
                            this.availableParameters[i].chosenValues = [{ value: this.availableParameters[i].chosenValues[0].value.toLowerCase() === "true" }];
                        }
                        if (this.availableParameters[i].fieldTypeName === 'Boolean' && this.availableParameters[i].chosenValues.length === 0) {
                            this.availableParameters[i].chosenValues = [{ value: false }];
                        }
                        // Init text fields, if no default value
                        if (this.availableParameters[i].fieldTypeName === 'TextField' && (this.availableParameters[i].chosenValues === null || undefined)) {
                            this.availableParameters[i].chosenValues = [{ value: "" }];
                        }
                        // Init date fields
                        if (this.availableParameters[i].fieldTypeName === 'Date') {
                            this.initDateParameter(this.availableParameters[i]);
                        }
                    }
                    this.registerDateParameterWatchers();
                }).catch(() => {
                    this.isLoadingParams = false;
                    this.isParamsLoadingError = true;
                });
            }
            initDateParameter(parameter) {
                if (!parameter.chosenValues || parameter.chosenValues.length === 0) {
                    parameter.chosenValues = [{ value: '', specialValue: null }];
                }
                const chosen = parameter.chosenValues[0];
                if (chosen.specialValue != null && chosen.specialValue !== undefined) {
                    const resolvedDate = Reporting.ReportingSpecialValues.resolveDate(chosen.specialValue);
                    if (resolvedDate) {
                        chosen.dateValue = resolvedDate;
                        chosen.value = Reporting.ReportingSpecialValues.toDateOnlyString(resolvedDate);
                        return;
                    }
                }
                if (chosen.value) {
                    chosen.value = Reporting.ReportingSpecialValues.normalizeDateValue(chosen.value);
                    if (chosen.value) {
                        chosen.dateValue = moment(chosen.value, 'YYYY-MM-DD').toDate();
                    }
                }
            }
            registerDateParameterWatchers() {
                this.dateParameterWatcherDeregistrations.forEach(deregister => deregister());
                this.dateParameterWatcherDeregistrations = [];
                if (!this.availableParameters)
                    return;
                this.availableParameters.forEach(parameter => {
                    if (parameter.fieldTypeName !== 'Date')
                        return;
                    const deregister = this.$scope.$watch(() => { var _a, _b; return (_b = (_a = parameter.chosenValues) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.dateValue; }, (newValue) => {
                        var _a;
                        const chosen = (_a = parameter.chosenValues) === null || _a === void 0 ? void 0 : _a[0];
                        if (!chosen)
                            return;
                        chosen.value = newValue
                            ? Reporting.ReportingSpecialValues.toDateOnlyString(newValue)
                            : '';
                    });
                    this.dateParameterWatcherDeregistrations.push(deregister);
                });
            }
            getAvailableParameterValues(parameter) {
                this.additionalProperties = [];
                if (parameter.valueRange !== undefined && parameter.valueRange !== null && parameter.valueRange !== "") {
                    this.resetModal();
                    this.loadingParamValues = true;
                    this.showIsCurrent = false;
                    this.paramDateFilter = {
                        dateFrom: undefined,
                        dateTo: undefined,
                        enable: false
                    };
                    parameter.availableValues = [];
                    this.reportingService.getReportParameterValueList(parameter.fieldType, parameter.valueRange).then((data) => {
                        parameter.availableValues = data.items;
                        this.additionalProperties = data.additionalProperties;
                        // Set default values of available values as checked
                        for (let i = 0; i < parameter.availableValues.length; i++) {
                            for (let j = 0; j < parameter.chosenValues.length; j++) {
                                if (parameter.availableValues[i].id === parameter.chosenValues[j].id) {
                                    parameter.availableValues[i].isChecked = true;
                                }
                            }
                            if (!parameter.availableValues[i] !== (null || undefined) && !parameter.availableValues[i].isCurrent)
                                this.showIsCurrent = true;
                            if (parameter.availableValues[i].dateFrom || parameter.availableValues[i].dateTo)
                                this.paramDateFilter.enable = true;
                        }
                        //(parameter as any).availableValuesMap = this.$qui.selectAutoMap(data.items, 'objectId', 'name');
                        parameter.availableValuesMap = data.items.map(item => {
                            var _a, _b;
                            const subText = (_b = (_a = data.additionalProperties) === null || _a === void 0 ? void 0 : _a.map((ap, index) => item.additionalProperties[index].length ? `${ap}: ${item.additionalProperties[index]}` : undefined).filter(x => x === null || x === void 0 ? void 0 : x.length).join('; ')) !== null && _b !== void 0 ? _b : '';
                            return {
                                text: item.name,
                                value: item.objectId,
                                subText
                            };
                        });
                        const dateFromParam = this.availableParameters.filter(x => x.name.toLowerCase() === 'datum von')[0];
                        const dateToParam = this.availableParameters.filter(x => x.name.toLowerCase() === 'datum bis')[0];
                        if (dateFromParam && dateFromParam.fieldType === 10 && dateFromParam.chosenValues.length > 0)
                            this.paramDateFilter.dateFrom = dateFromParam.chosenValues[0].dateValue;
                        if (dateToParam && dateToParam.fieldType === 10 && dateToParam.chosenValues.length > 0)
                            this.paramDateFilter.dateTo = dateToParam.chosenValues[0].dateValue;
                        this.currentParameter = parameter;
                        this.loadingParamValues = false;
                    });
                }
            }
            allRequiredFieldsFilled() {
                var _a;
                let result = (_a = this.availableParameters) === null || _a === void 0 ? void 0 : _a.reduce((allPresent, param) => {
                    if (!param.isRequired)
                        return allPresent;
                    switch (param.fieldTypeName) {
                        case 'Date':
                            return allPresent && param.chosenValues.some(x => x.dateValue !== undefined && x.dateValue !== null);
                        default:
                            return allPresent && param.chosenValues.some(x => x.value !== undefined && x.value !== null);
                    }
                }, true);
                return result !== null && result !== void 0 ? result : false;
            }
            valueInDateRange(param) {
                if (!this.paramDateFilter.enable)
                    return true;
                // map dates to min/max date if unset to make actual filtering easier
                const filterStartDate = this.paramDateFilter.dateFrom ? new Date(this.paramDateFilter.dateFrom.toString()) : new Date(-8640000000000000);
                const filterEndDate = this.paramDateFilter.dateTo ? new Date(this.paramDateFilter.dateTo.toString()) : new Date(+8640000000000000);
                const paramStartDate = param.dateFrom ? new Date(param.dateFrom.toString()) : new Date(-8640000000000000);
                const paramEndDate = param.dateTo ? new Date(param.dateTo.toString()) : new Date(+8640000000000000);
                if (filterStartDate <= paramStartDate && paramStartDate <= filterEndDate)
                    return true; // param starts in filter
                if (filterStartDate <= paramEndDate && paramEndDate <= filterEndDate)
                    return true; // param ends in filter
                if (paramStartDate <= filterStartDate && filterEndDate <= paramEndDate)
                    return true; // filter in param
                return false;
            }
            resetModal() {
                this.parameterValueFilterText = "";
                this.selectAll = false;
                this.onlyActive = true;
            }
            addMultiSelectedValues() {
                const selectedValues = [];
                for (let i = 0; i < this.currentParameter.availableValues.length; i++) {
                    if (this.currentParameter.availableValues[i].isChecked && (!this.onlyActive || this.currentParameter.availableValues[i].isCurrent)) {
                        selectedValues.push({
                            id: this.currentParameter.availableValues[i].id,
                            objectId: this.currentParameter.availableValues[i].objectId,
                            value: this.currentParameter.availableValues[i].objectId,
                            caption: this.currentParameter.availableValues[i].name !== null && this.currentParameter.availableValues[i].name !== undefined ? this.currentParameter.availableValues[i].name : "",
                            dateValue: null
                        });
                    }
                }
                this.currentParameter.chosenValues = selectedValues;
                this.currentParameter.selectionString = "";
                // Generate selection string:
                for (let i = 0; i < this.currentParameter.chosenValues.length; i++) {
                    this.currentParameter.selectionString += this.currentParameter.chosenValues[i].caption + "; ";
                }
            }
            getReportType() {
                for (let i = 0; i < this.templateList.length; i++) {
                    if (this.templateList[i].objectId === this.selectedTemplateId) {
                        return this.templateList[i].reportTypeValue;
                    }
                }
                return 0;
            }
            generateReport() {
                this.generateReportId = this.getNewGuid();
                // Fill date values from dateValue property into value property (date-only)
                for (let i = 0; i < this.availableParameters.length; i++) {
                    if (this.availableParameters[i].fieldTypeName === 'Date' && this.availableParameters[i].chosenValues.length > 0) {
                        const chosen = this.availableParameters[i].chosenValues[0];
                        chosen.value = Reporting.ReportingSpecialValues.toDateOnlyString(chosen.dateValue);
                        if (chosen.specialValue != null && chosen.specialValue !== undefined && chosen.dateValue) {
                            const resolvedDate = Reporting.ReportingSpecialValues.resolveDate(chosen.specialValue);
                            if (!resolvedDate || !moment(chosen.dateValue).isSame(resolvedDate, 'day'))
                                chosen.specialValue = null;
                        }
                    }
                }
                const params = angular.copy(this.availableParameters);
                const postItem = {
                    reportObjectId: this.selectedTemplateId,
                    serverJobObjectId: this.generateReportId,
                    reportType: this.getReportType(),
                    parameters: params,
                    isCancelled: false,
                    detailParentId: this.isDetail() ? this.selectedDetailId : null
                };
                //remove potentially large and not needed availableParameters prop
                for (const param of postItem.parameters) {
                    if (param.availableValues) {
                        param.chosenValues.forEach(val => {
                            const avVal = param.availableValues.filter(x => x.objectId === val.value);
                            if (avVal && avVal.length > 0)
                                val.caption = avVal[0].name;
                        });
                        delete param.availableValues;
                        delete param.availableValuesMap;
                    }
                    if (param.description)
                        delete param.description;
                }
                this.postReportJobCancel = this.$q.defer();
                this.reportingService.postReportJob(postItem, this.postReportJobCancel.promise).then((id) => {
                    this.handleFinishedReport(id);
                }).catch((id) => {
                    this.handleFinishedReport(id);
                }).finally(() => {
                    this.postReportJobCancel = null;
                });
            }
            handleFinishedReport(id) {
                if (typeof id !== "string" || !id.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$")) {
                    //if (typeof id != "string") {
                    $('#loadingScreen').modal('hide');
                    $('#downloadError').modal('show');
                    return;
                }
                if (this.generateReportId !== null && this.generateReportId !== undefined) {
                    this.getFinishedReportFile(id);
                    this.generateReportId = null;
                }
            }
            getFinishedReportFile(id) {
                this.reportFileId = id;
                this.fileName = this.getSelectedReportName();
                this.reportingService.getFinishedReportBase64(id, this.getReportType(), this.fileName).then((data) => {
                    $('#loadingScreen').modal('hide');
                    this.fileType = data.filename.substring(data.filename.lastIndexOf('.') + 1);
                    this.base64Data = data.base64;
                    this.fileName = data.filename;
                    $('#loadingScreenModal').modal('hide');
                    $('html,body').animate({
                        scrollTop: $("#docBox").offset().top
                    }, 1000);
                });
            }
            scrollToViewer() {
                this.$qui.scopeApply(this.$scope);
                setTimeout(() => {
                    if (this.scrollTarget === 'pdf')
                        $('html,body').animate({
                            scrollTop: $("#docBox").offset().top
                        }, 1000);
                    if (this.scrollTarget === 'spread')
                        $('html,body').animate({
                            scrollTop: $("#spreadBox").offset().top - 25
                        }, 1000);
                }, 500);
            }
            cancelReportJob() {
                this.reportingService.cancelRunningReportJob(this.generateReportId);
                this.generateReportId = null;
            }
            runInBackground() {
                this.generateReportId = null;
            }
            getDescription() {
                for (let i = 0; i < this.templateList.length; i++) {
                    if (this.selectedTemplateId === this.templateList[i].id)
                        return this.templateList[i].description;
                }
                return '';
            }
            isDetail() {
                for (let i = 0; i < this.templateList.length; i++) {
                    if (this.selectedTemplateId === this.templateList[i].id)
                        return this.templateList[i].isDetail;
                }
                return false;
            }
            getExplanationFileId() {
                var _a;
                const explanationId = (_a = this.templateList.filter(x => x.id === this.selectedTemplateId)[0]) === null || _a === void 0 ? void 0 : _a.explanationFileId;
                return explanationId !== null && explanationId !== void 0 ? explanationId : QMC.Common.Constants.GUID_EMPTY;
            }
            hasExplanationFile() {
                return this.getExplanationFileId() !== QMC.Common.Constants.GUID_EMPTY;
            }
            openExplanationFile() {
                const id = this.getExplanationFileId();
                if (id === QMC.Common.Constants.GUID_EMPTY) {
                    console.error(`No explanationId for template: ${this.selectedTemplateId}`);
                    return;
                }
                this.explanationFile.isLoading = true;
                $('#previewModal').modal('show');
                this.mediaService.getMediaFile(id)
                    .then((data) => {
                    this.explanationFile.data = data;
                    const temp = data.filename.split('.');
                    this.explanationFile.suffix = temp[temp.length - 1];
                })
                    .catch((e) => { })
                    .finally(() => this.explanationFile.isLoading = false);
            }
            getSelectedReportName() {
                for (let i = 0; i < this.templateList.length; i++) {
                    if (this.templateList[i].objectId === this.selectedTemplateId)
                        return this.replaceUmlauts(this.templateList[i].name);
                }
                return "report";
            }
            toggleAllCheckboxes() {
                const toggleState = this.selectAll;
                if (!this.$scope.filteredBoxes)
                    return;
                for (let i = 0; i < this.$scope.filteredBoxes.length; i++) {
                    this.$scope.filteredBoxes[i].isChecked = toggleState;
                }
                this.$qui.scopeApply(this.$scope);
            }
            getParamTableHeight() {
                return document.body.clientHeight - 320;
            }
            /* replaces any umlauts whether upper or lower case with its corresponing ANSII compatible characters  */
            replaceUmlauts(fileName) {
                const umlautMap = {
                    '\u00dc': 'UE',
                    '\u00c4': 'AE',
                    '\u00d6': 'OE',
                    '\u00fc': 'ue',
                    '\u00e4': 'ae',
                    '\u00f6': 'oe',
                    '\u00df': 'ss',
                };
                const result = fileName.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
                    const big = umlautMap[a.slice(0, 1)];
                    return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
                }).replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"), (a) => umlautMap[a]);
                return this.removeInvalidChars(result);
            }
            removeInvalidChars(fileName) {
                const fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
            }
        };
        ReportingController = __decorate([
            QMC.Controller('QMC.Reporting', 'ReportingController'),
            QMC.Inject('ReportingService', '$qui', '$state', '$scope', '$rootScope', 'QmcMediaService', '$q')
        ], ReportingController);
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        let ReportPreviewListController = class ReportPreviewListController {
            /*constructor*/
            constructor($qui, lngService, reportingService, userService, $location, $scope, $state, $stateParams) {
                this.$qui = $qui;
                this.lngService = lngService;
                this.reportingService = reportingService;
                this.userService = userService;
                this.$location = $location;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                /*Interface*/
                this.ui = new Reporting.UserInterfaceReportPreview();
                this.reportingJobsRetentionDaysConfigKey = "MaintenanceJob.ReportingServerJobsRetentionDays";
                this.defaultReportingJobsRetentionDays = 7;
                this.tableFilter = "";
                /*variables*/
                this.finishedReportList = [];
                this.selectedForRemovalList = [];
                this.shouldLoadTableData = true;
                this.debounceChkBx = false;
                this.page = 0;
                this.sortBy = '';
                this.sortDescending = false;
                this.formState = 'new';
                this.loading = {
                    list: false,
                    unfetched: false,
                    daysInPast: 7,
                    firstLoad: true,
                    page: 0,
                    tableFilter: ''
                };
                this.errorInfoModalMessage = {
                    serverMessage: '',
                    errorTrace: ''
                };
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.init();
                this.loadReportingJobsRetentionHint();
                if ($stateParams.id !== undefined) {
                    this.externallySelectedReportId = $stateParams.id;
                }
                this.$qui.getTableAutoload(this.userService).then((ltd) => {
                    this.shouldLoadTableData = ltd;
                    this.userService.getUserSettings(["DLGREPORTINGSERVERJOBS.DAYSINPAST", "DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED"], false).then((data2) => {
                        this.daysInPast = parseInt(data2[0].value);
                        this.showOnlyUnfetchedData = (data2[1].value.toLowerCase() === "true");
                        this.loading.daysInPast = this.daysInPast;
                        this.loading.unfetched = this.showOnlyUnfetchedData;
                        if (this.shouldLoadTableData) {
                            this.getData();
                            this.$scope.$watch('vm.tableFilter', (newValue, oldValue) => {
                                if (newValue === oldValue)
                                    return;
                                const current = this.tableFilter;
                                setTimeout(() => {
                                    if (current === this.tableFilter) {
                                        this.page = 0;
                                        this.getData();
                                    }
                                    this.$qui.scopeApply(this.$scope);
                                }, 500);
                            });
                            this.$scope.$watch('vm.daysInPast', (newValue, oldValue) => {
                                if (newValue === oldValue)
                                    return;
                                const current = this.daysInPast;
                                setTimeout(() => {
                                    if (current === this.daysInPast) {
                                        this.page = 0;
                                        this.getData();
                                    }
                                    this.$qui.scopeApply(this.$scope);
                                }, 500);
                            });
                            this.$scope.$watch('vm.showOnlyUnfetchedData', (newValue, oldValue) => {
                                if (newValue !== oldValue && !this.debounceChkBx) {
                                    this.debounceChkBx = true;
                                    setTimeout(() => {
                                        this.page = 0;
                                        this.getData();
                                        this.debounceChkBx = false;
                                    }, 250);
                                }
                            });
                        }
                    });
                });
            }
            loadReportingJobsRetentionHint() {
                this.userService.getGlobalSettings([this.reportingJobsRetentionDaysConfigKey], false).then((data) => {
                    var _a;
                    const parsedDays = parseInt((_a = data[0]) === null || _a === void 0 ? void 0 : _a.value, 10);
                    const retentionDays = !isNaN(parsedDays) && parsedDays > 0
                        ? parsedDays
                        : this.defaultReportingJobsRetentionDays;
                    this.reportingJobsRetentionHint = this.$qui.formatString(this.lngService.translate(20015081, "Ausgeführte Auswertungen werden nach {0} Tagen gelöscht."), retentionDays);
                });
            }
            /*local init*/
            init() {
                this.$scope.$watch('vm.page', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.getData();
                });
                this.promptOptions = {
                    title: this.lngService.translate(20002016, "Hinweis"),
                    yesNo: true,
                    icon: "qm-icon-trash",
                    text: this.lngService.translate(20015049, "Wollen Sie die Auswertung wirklich löschen?")
                };
                this.promptOptionsMulti = {
                    title: this.lngService.translate(20002016, "Hinweis"),
                    yesNo: true,
                    icon: "qm-icon-trash",
                    text: this.lngService.translate(20015056, "Wollen Sie die ausgewählten Auswertungen wirklich löschen?")
                };
            }
            /*acquire finished reports from server*/
            getData() {
                if ((this.loading.daysInPast === this.daysInPast) && (this.loading.unfetched === this.showOnlyUnfetchedData) && (this.loading.page === this.page)
                    && (this.tableFilter === undefined) && !this.loading.firstLoad)
                    return;
                this.loading.firstLoad = false;
                this.loading.list = true;
                this.reportingService.getFinishedReportList(this.showOnlyUnfetchedData, this.daysInPast, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.tableFilter, this.ui.getDisplayedPropertiesFromSchema(this.ui.reportPreviewTable), this.sortBy, this.sortDescending).then((data) => {
                    for (const item of data.items) {
                        if (!item.showPreviewButton) {
                            if (!item.showDeleteButton)
                                item.style = { 'color': 'orange', 'font-weight': 'bold', 'height': '55px' };
                            else if (item.isSpreadSheet)
                                item.style = { 'color': 'black', 'font-weight': 'normal' };
                            else
                                item.style = { 'color': 'red', 'font-weight': 'bold' };
                        }
                    }
                    this.paginationInfo = data.paginationInfo;
                    this.finishedReportList = this.checkPreviouslyMarkedItemsAgain(data.items);
                    this.ui.reportPreviewTable.data = this.finishedReportList;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading.list = false;
                    this.loading.unfetched = this.showOnlyUnfetchedData;
                    this.loading.daysInPast = this.daysInPast;
                    this.loading.page = this.page;
                    if (this.externallySelectedReportId !== undefined) {
                        for (const finishedReport of this.finishedReportList) {
                            if (finishedReport.objectId === this.externallySelectedReportId) {
                                this.selectedReportObject = finishedReport;
                                this.getFinishedReportFile(finishedReport);
                            }
                        }
                    }
                    this.$qui.scopeApply(this.$scope);
                    $('html,body').animate({
                        scrollTop: $("#docuBox").offset().top - 25
                    }, 500);
                });
            }
            refresh(value) {
                this.resetFormProperties(value);
                this.getData();
                this.setWidgetRefresh();
            }
            /*acquires the finished report file from the server for preview*/
            getFinishedReportFile(reportObject) {
                console.log("Getting file for ", reportObject.reportName);
                this.base64Data = undefined;
                this.reportingService.getFinishedReportFile(reportObject).then((data) => {
                    this.base64Data = data.base64;
                    this.fileName = data.filename;
                    this.reportFileId = data.objectId;
                    this.resetFormProperties(false);
                    this.getData();
                    this.setWidgetRefresh();
                    setTimeout(() => {
                        if (reportObject.serverJobType === 6000 || reportObject.serverJobType === 7000) {
                            //pdf files - serverJobType 6000 (form template) & 7000 (normal report))
                            this.fileType = 'pdf';
                        }
                        else if (reportObject.serverJobType === 3000) {
                            //xls files - serverJobType 3000
                            this.fileType = 'excel';
                        }
                        $('#loadingScreenModal').modal('hide');
                        this.$qui.scopeApply(this.$scope);
                        $('html,body').animate({
                            scrollTop: $("#docuBox").offset().top - 25
                        }, 500);
                    }, 500);
                });
            }
            getPdfXlsFile(getPdf) {
                if (getPdf) {
                    $('#loadingScreenModal').modal('show');
                    this.reportingService.getFinishedSpreadServerJobAsPdf(this.selectedReportObject.objectId, this.selectedReportObject.reportName).then((data) => {
                        this.base64Data = data.base64;
                        this.fileType = 'pdf';
                        setTimeout(() => {
                            this.$qui.scopeApply(this.$scope);
                            $('#loadingScreenModal').modal('hide');
                            $('html,body').animate({
                                scrollTop: $("#pdfViewer").offset().top
                            }, 500);
                            //refresh table after animation/scrolling down
                            this.refresh(false);
                        }, 1000);
                    });
                }
                else {
                    let absoluteUrl = window.location.href;
                    const sessionData = $('#session').data();
                    absoluteUrl = absoluteUrl.replace(window.location.hash, "");
                    const correctedFileName = this.replaceUmlauts(this.selectedReportObject.reportName);
                    const completeUrl = absoluteUrl + 'Reporting/FinishedReportFile?apiPath=' + sessionData.api + '&finishedReportJobObjectId='
                        + this.selectedReportObject.objectId + '&finishedReportType=' + this.selectedReportObject.serverJobType + '&finishedReportName='
                        + correctedFileName + '&spreadAsPdf=' + false + '&bearer=' + this.reportingService.getAccessToken();
                    window.open(completeUrl);
                    setTimeout(() => {
                        this.refresh(false);
                    }, 1000);
                }
            }
            /* deletes a given finished report database entry and its files*/
            deleteFinishedReport(reportObject) {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.loading.list = true;
                        this.finishedReportList = [];
                        console.log("finished report '%s' is being deleted right now...", reportObject.reportName);
                        this.reportingService.deleteSelectedReport(reportObject).then((data) => {
                            if (data.isDeleteDataBaseEntrySuccessful || data.isDeleteFileSuccessful) {
                                this.$qui.notify(this.$qui.deleteNote);
                                this.refresh(true);
                            }
                        });
                    }
                }, '#promptSingle');
            }
            /* reset all previously set properties */
            resetFormProperties(refreshall) {
                this.selectedReportObject = null;
                this.selectedForRemovalList = [];
                this.externallySelectedReportId = undefined;
                this.finishedReportList = [];
                this.ui.reportPreviewTable.data = [];
                if (refreshall) {
                    this.base64Data = undefined;
                    this.fileType = undefined;
                }
            }
            prepareReportPreview(reportObject) {
                $('#loadingScreenModal').modal('show');
                this.selectedReportObject = reportObject;
                this.getFinishedReportFile(reportObject);
            }
            /* replaces any umlauts whether upper or lower case with its corresponing ANSII compatible characters  */
            replaceUmlauts(fileName) {
                const umlautMap = {
                    '\u00dc': 'UE',
                    '\u00c4': 'AE',
                    '\u00d6': 'OE',
                    '\u00fc': 'ue',
                    '\u00e4': 'ae',
                    '\u00f6': 'oe',
                    '\u00df': 'ss',
                };
                const result = fileName.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
                    const big = umlautMap[a.slice(0, 1)];
                    return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
                }).replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"), (a) => umlautMap[a]);
                return this.removeInvalidChars(result);
            }
            removeInvalidChars(fileName) {
                const fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
            }
            /* fired when a check in the table is clicked - adds/removes the report from the selected row to list of items to be disposed of */
            selectForRemoval(checked, item) {
                if (checked) {
                    this.selectedForRemovalList.push(item);
                }
                else {
                    for (let i = 0; i < this.selectedForRemovalList.length; i++) {
                        if (this.selectedForRemovalList[i] === item) {
                            this.selectedForRemovalList.splice(i, 1);
                        }
                    }
                }
            }
            /* Removes a list of given finished reports */
            removeSelectedReports() {
                QMC.Common.Utilities.confirm(this.promptOptionsMulti, (data) => {
                    if (data) {
                        $('#deletionAwaitModal').modal('show');
                        this.loading.list = true;
                        this.finishedReportList = [];
                        this.reportingService.deleteSelectedReports(this.selectedForRemovalList).then(() => {
                            $('#deletionAwaitModal').modal('hide');
                            if (this.selectedForRemovalList.length > 1)
                                this.$qui.notify(this.$qui.deleteNotes);
                            else if (this.selectedForRemovalList.length === 1)
                                this.$qui.notify(this.$qui.deleteNote);
                            this.refresh(true);
                        });
                    }
                    else {
                        $('#deletionAwaitModal').modal('hide');
                    }
                }, '#promptMulti');
            }
            checkPreviouslyMarkedItemsAgain(items) {
                if (this.selectedForRemovalList.length === undefined || this.selectedForRemovalList.length === 0)
                    return items;
                const modifiedData = items;
                modifiedData.forEach(element => {
                    element.isSelected = false;
                });
                for (let i = 0; i < modifiedData.length; i++) {
                    const reportId = modifiedData[i].objectId;
                    for (let j = 0; j < this.selectedForRemovalList.length; j++) {
                        if (this.selectedForRemovalList[j].objectId === reportId) {
                            //because reportPreviewTable.data and finishedReportList are the same list
                            modifiedData[i].isSelected = true;
                        }
                    }
                }
                return modifiedData;
            }
            setWidgetRefresh() {
                $('#qmUnfetchedReports').attr('qm-refresh', 'true');
            }
            showErrorInfoModal(reportObject) {
                this.errorInfoModalMessage.serverMessage = reportObject.serverMessage;
                this.errorInfoModalMessage.errorTrace = reportObject.errorTrace;
                $('#errorInfoModal').modal('show');
                this.setFaultyReportFetched(reportObject);
            }
            setFaultyReportFetched(serverJobObject) {
                if (!serverJobObject.isFetched) {
                    this.reportingService.markReportFetched(serverJobObject.objectId).then(() => {
                        for (let i = 0; i < this.finishedReportList.length; i++) {
                            const element = this.finishedReportList[i];
                            if (element.objectId === serverJobObject.objectId)
                                element.isFetched = true;
                        }
                        this.ui.reportPreviewTable.data = this.finishedReportList;
                        this.$qui.functionWaiter("ui.createTable", this);
                        this.setWidgetRefresh();
                    });
                }
            }
        };
        ReportPreviewListController = __decorate([
            QMC.Controller('QMC.Reporting', 'ReportPreviewListController'),
            QMC.Inject('$qui', 'QmcLanguageService', 'ReportingService', 'UserService', '$location', '$scope', '$state', '$stateParams')
        ], ReportPreviewListController);
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        /**
         * Report preview user interface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         *
         * */
        class UserInterfaceReportPreview extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                /*
                 * finished Reportlist table
                 * @memberOf UserInterface
                 */
                this.reportPreviewTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false"
                    },
                    "table": {
                        "Löschen": {
                            "id": "objectId",
                            "selected": "isSelected",
                            "dType": "Checkbox",
                            "lngTag": "20000002",
                            "events": {
                                "onChange": "selectForRemoval"
                            }
                        },
                        "Vorlagentyp": {
                            "label": "reportTypeString",
                            "dType": "string",
                            "lngTag": "20015032"
                        },
                        "Status": {
                            "label": "jobStatus",
                            "dType": "string",
                            "lngTag": "20000164",
                            "style": "style"
                        },
                        "Auswertung": {
                            "label": "reportName",
                            "dType": "string",
                            "lngTag": "20015030"
                        },
                        "Startzeit": {
                            "label": "startTime",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20015029"
                        },
                        "Endzeit": {
                            "label": "finishTime",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20015054"
                        },
                        "Abgeholt": {
                            "label": "isFetched",
                            "dType": "Bool",
                            "lngTag": "20015031"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "prepareReportPreview",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "20015033",
                                "events": {
                                    "hide": "!showPreviewButton"
                                },
                            },
                            {
                                "icon": "qm-icon-information orange",
                                "click": "showErrorInfoModal",
                                "dType": "Button",
                                "tooltip": "Fehlerinfo",
                                "lngTag": "20015062",
                                "hideSpacer": "hasBeenCanceled",
                                "events": {
                                    "hide": "!showInfoButton"
                                },
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFinishedReport",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!showDeleteButton"
                                },
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-form"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "reportName",
                                "dType": "string"
                            },
                            {
                                "label": "reportTypeString",
                                "dType": "string"
                            },
                            {
                                "label": "isFetched",
                                "dType": "Bool"
                            },
                            {
                                "label": "finishTime",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "prepareReportPreview",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "20015033",
                                "events": {
                                    "hide": "!showPreviewButton"
                                }
                            },
                            {
                                "icon": "qm-icon-information orange",
                                "click": "showErrorInfoModal",
                                "dType": "Button",
                                "tooltip": "Fehlerinfo",
                                "lngTag": "20015062",
                                "hideSpacer": "hasBeenCanceled",
                                "events": {
                                    "hide": "!showInfoButton"
                                }
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFinishedReport",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!showDeleteButton"
                                }
                            }
                        ]
                    },
                    "data": null
                };
            }
        }
        Reporting.UserInterfaceReportPreview = UserInterfaceReportPreview;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Reporting/qmc.reporting.js.map
